<mat-checkbox [formControl]="control" [name]="name" [required]="required">
  <span [innerHTML]="label"></span>
</mat-checkbox>
